<template>
    <div class="left-menu animated fadeInLeft">
        <div class="proof animated fadeInLeft" :style="'background-image:url('+proof+')'"></div>
        <div class="content">
            <div class="left animated">
                <div class="city-name" :class="{'location-move':projectOpened}">
                    <i class="iconfont icon-diliweizhi"
                       :style="'font-size:'+(projectOpened?'14px':'20px')"></i>{{this.currCity}}
                    {{projectOpened?this.levelName:''}}
                </div>
                <div v-for="(item,index) in projectCount"
                     @click="selectLevel(index)"
                     :class="{'cate-selected':item.selected,'fadeInLeft':left,'fadeOutLeft':!left}"
                     class="animated cate">
                    <i class="iconfont icon-xuanze-kong" :class="{'icon-xuanze':item.selected}"></i>
                    {{item.level_name}}：{{item.count}}个
                </div>
            </div>
            <div class="search-bar" v-show="!projectOpened">
                <input type="text" placeholder="请输入关键字..." v-model="title">
                <div class="search-btn" @click="search">
                    <i class="iconfont icon-sousuo"></i>
                </div>
            </div>
            <div class="right animated fadeInUp"
                 :style="'overflow-y:'+(projectOpened?'visible':'scroll')">
                <loading v-if="loading" title="正在加载项目"></loading>
                <no-data v-if="projectList.length <=0 && !loading" title="该分类下没有项目"></no-data>
                <div class="card" :id="'card_'+index" :class="item.className"
                     :style="'opacity:'+(item.show?'1':'0')+';transform: scale('+item.scale+') translate('+item.offsetX+'px,'+item.offsetY+'px)'"
                     v-for="(item,index) in projectList"
                     @click="doSelect(index,item.id)">
                    <div class="thumb"
                         :style="'background-image:url('+item.cover_pic+')'"></div>
                    <div class="project-info">
                        <div class="title">{{item.title}}</div>
                        <div class="sub-info">
                            <span>{{item.cate_name}}</span>
                            <span>{{item.year}}</span>
                            <span>{{item.city_name}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="details-content animated" :class="{'fadeIn':projectOpened}"
                 v-if="projectOpened">
                <div class="intro-content animated" :class="{'fadeIn':projectOpened}">
                    {{projectIntro}}...<span @click="showProjectAllIntro">【查看简介】</span>
                </div>
                <div class="bottom-menu animated" :class="{'fadeInUp':projectOpened}">
                    <div class="menu-item" v-for="(item,index) in menu"
                         @click="selectCate(index)">
                        <div>
                            <img
                                :src="item.icon"
                                width="30" height="30">
                        </div>
                        <div class="menu-name" :class="{'menu-name-selected':item.selected}">
                            {{item.name}}
                        </div>
                        <div class="select" v-show="item.selected">
                            <i class="iconfont icon-jiantouarrow492"></i>
                        </div>
                    </div>
                    <div class="menu-item" @click="openNews">
                        <div>
                            <img :src="news" width="30" height="30">
                        </div>
                        <div class="menu-name">
                            新闻
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import images from "@/assets/icon/images.png"
    import video from "@/assets/icon/video.png"
    import audio from "@/assets/icon/audio.png"
    import doc from "@/assets/icon/doc.png"
    import link from "@/assets/icon/link.png"
    import news from "@/assets/icon/news.png"
    import proof from "@/assets/images/proof.png"

    export default {
        name: "left-menu",
        data() {
            return {
                projectList: [
                    // {className: '', offsetX: 0, offsetY: 0, scale: 1, show: true},
                ],
                left: true,
                projectCount: [],
                level: '',
                levelName: '全部',
                menu: [
                    {selected: true, name: '图集', icon: images, media: 'images'},
                    {selected: false, name: '视频', icon: video, media: 'video'},
                    {selected: false, name: '传承人', icon: link, media: 'successor'},
                    {selected: false, name: '文档', icon: doc, media: 'files'},
                ],
                proof: proof,
                loading: false,
                projectIntro: "",
                currIndex: 0,
                title: "",
                news: news,
                projectId: ""
            }
        },
        filters: {
            shortText: function (value) {
                return value.substring(0, 100);
            }
        },
        methods: {
            doSelect: function (index, projectId) {
                this.projectId = projectId;
                this.$store.commit('projectSwitch');
                this.$store.commit('componentsSwitch', 'imageList');
                this.projectList[index].className = 'card-selected';
                this.left = false;
                let id = "#card_" + index;
                let card = document.querySelector(id);
                let offsetY = card.offsetTop;
                this.projectList[index].offsetX = '-30';
                this.projectList[index].offsetY = -offsetY + 10 + (index * 18);
                this.projectList[index].scale = 1.2;
                this.projectList.forEach((row, itemIndex) => {
                    if (itemIndex !== index) {
                        row.show = false;
                    }
                });
                this.projectIntro = this.projectList[index].details_short;
                this.selectCate(0);
                this.$store.commit('setLoadingContent', true);
                this.$store.commit('setProjectDetails', {
                    images_list: [],
                    files_list: [],
                    media_list: [],
                    successor_list: [],
                });
                this.$http.request('projectDetails', {project_id: projectId}).then(res => {
                    this.$store.commit('setLoadingContent', false);
                    this.$store.commit('setProjectDetails', res.data);
                });
                this.$http.addViews(projectId, 5);
                this.currIndex = index;
            },
            close: function () {
                this.left = true;
                this.projectList.forEach((row) => {
                    row.show = true;
                    row.className = '';
                    row.offsetX = 0;
                    row.offsetY = 0;
                    row.scale = 1;
                });
            },
            openNews: function () {
                window.open("/news/list?project_id=" + this.projectId);
            },
            selectCate: function (index) {
                this.$store.commit('setShowContent', false);
                this.menu.forEach((row, rowIndex) => {
                    row.selected = (index === rowIndex);
                });
                this.$store.commit('setCurrContentMenu', this.menu[index]);
                setTimeout(() => {
                    this.$store.commit('setShowContent', true);
                }, 300)
            },
            selectLevel: function (index) {
                this.projectCount.forEach((row, currIndex) => {
                    row.selected = currIndex === index;
                });
                this.level = this.projectCount[index].level > 0 ? this.projectCount[index].level : '';
                this.levelName = this.projectCount[index].level_name;
                this.title = "";
                this.getProjectList();
            },
            getProjectList: function () {
                this.loading = true;
                this.projectList = [];
                this.$http.request('projectList', {
                    city: this.currCity,
                    level: this.level,
                    title: this.title
                }).then(res => {
                    this.loading = false;
                    if (res.status === 'success') {
                        res.data.forEach(row => {
                            row.className = '';
                            row.offsetX = 0;
                            row.offsetY = 0;
                            row.scale = 1;
                            row.show = true;
                        });
                        this.projectList = res.data;
                    }
                });
            },
            search: function () {
                this.loading = true;
                this.projectList = [];
                this.$http.request('projectList', {title: this.title}).then(res => {
                    this.loading = false;
                    if (res.status === 'success') {
                        res.data.forEach(row => {
                            row.className = '';
                            row.offsetX = 0;
                            row.offsetY = 0;
                            row.scale = 1;
                            row.show = true;
                        });
                        this.projectList = res.data;
                    }
                });
            },
            getProjectCount: function () {
                this.$http.request('projectCountByLevel', {city: this.currCity}).then(res => {
                    if (res.status === 'success') {
                        res.data.forEach((row, index) => {
                            row.selected = index === 0;
                        });
                        this.projectCount = res.data;
                    }
                });
            },
            showProjectAllIntro: function () {
                this.$store.commit('setProjectIntro', {
                    projectInfo: this.projectList[this.currIndex],
                    show: true
                })
            }
        },
        created: function () {
            this.getProjectList();
            this.getProjectCount();
        },
        computed: {
            ...mapGetters([
                'projectOpened', 'media', 'currCity'
            ]),
        },
        watch: {
            projectOpened: function () {
                if (!this.projectOpened) {
                    this.close();
                }
            },
            currCity: function () {
                this.level = '';
                this.title = '';
                this.getProjectList();
                this.getProjectCount();
            }
        }
    }
</script>

<style scoped lang="less">
    .left-menu {
        width: 650px;
        height: 100vh;
        left: 0;
        top: 0;
        background: #fff;
        position: absolute;
        z-index: 0;

        .proof {
            position: absolute;
            width: 100%;
            height: 60%;
            bottom: 0;
            background: no-repeat left 50%;
            background-size: contain;
            z-index: 1;
            animation-duration: 1.3s;
        }

        .content {
            z-index: 10;
            display: flex;
            width: 100%;
            margin-top: 130px;
            padding: 0 50px;
            color: #333;
            position: relative;
            overflow-y: hidden;

            .search-bar {
                width: 49%;
                height: 40px;
                border-radius: 5px;
                border: 1px solid #e4e4e4;
                margin-bottom: 15px;
                outline: none;
                color: #808080;
                display: flex;
                overflow: hidden;
                position: absolute;
                right: 11%;

                input {
                    flex-grow: 1;
                    height: 100%;
                    outline: none;
                    border: 0;
                    padding-left: 10px;
                    font-size: 15px;
                }

                .search-btn {
                    width: 15%;
                    height: 100%;
                    background: #e4e4e4;
                    text-align: center;
                    padding-top: 10px;
                    cursor: pointer;
                }
            }

            .left {
                width: 35%;
                padding-left: 30px;

                .city-name {
                    font-size: 22px;
                    font-weight: bold;
                    margin-bottom: 20px;
                    transition: all ease .5s;
                }

                .cate {
                    font-size: 15px;
                    margin-bottom: 15px;
                    cursor: pointer;
                    transition: all ease .4s;

                    i {
                        font-size: 13px;
                    }
                }

                .cate-selected, .cate:hover {
                    font-weight: bolder;
                    color: orange;
                    letter-spacing: 1px;
                }
            }

            .right {
                width: 65%;
                margin-top: 50px;
                max-height: 70vh;
                padding: 10px 20px;

                .card {
                    width: 100%;
                    padding: 10px;
                    box-shadow: 1px 1px 8px #ccc;
                    margin-bottom: 30px;
                    border-radius: 10px;
                    display: flex;
                    cursor: pointer;
                    transition: all ease .5s;
                    background: #fff;

                    .thumb {
                        width: 100px;
                        height: 60px;
                        border-radius: 5px;
                        background: no-repeat center center;
                        background-size: cover;
                    }

                    .project-info {
                        flex-grow: 1;
                        padding-left: 15px;

                        .title {
                            font-size: 15px;
                            font-weight: bold;
                        }

                        .sub-info {
                            font-size: 13px;
                            color: #666;
                            margin-top: 20px;

                            span {
                                padding: 0 5px;
                                border-right: 1px solid #9f9f9f;
                            }

                            span:first-child {
                                padding-left: 0;
                            }

                            span:last-child {
                                border-right: 0;
                            }
                        }
                    }
                }
            }
        }

        .card-selected {
            box-shadow: 0 0 0 transparent !important;
        }

        .details-content {
            width: 350px;
            height: 310px;
            border-top: 1px solid #000;
            border-bottom: 1px solid #000;
            position: absolute;
            top: 36px;
            right: 94px;
            padding-top: 135px;

            .intro-content {
                font-size: 12px;
                color: #888;
                margin-top: -15px;
                margin-bottom: 15px;
                display: -webkit-box;
                -webkit-line-clamp: 4;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-align: justify;
                line-height: 1.8;

                span {
                    color: orange;
                    cursor: pointer;
                }
            }

            .bottom-menu {
                height: 100px;
                display: flex;
                opacity: 0;

                .menu-item {
                    height: 100%;
                    width: 16.666666666%;
                    font-size: 14px;
                    text-align: left;
                    cursor: pointer;

                    .menu-name {
                        font-size: 13px;
                        padding-top: 5px;
                    }

                    .menu-name-selected {
                        color: orange;
                    }

                    .select {
                        color: orange;
                        padding-top: 5px;
                        padding-left: 4px;
                    }
                }
            }
        }

        .location-move {
            transform: translateX(130px);
            font-size: 14px !important;
        }
    }
</style>